"use strict";
function configureForm(resultContainer, currentFormEl, spinner) {
    const method = currentFormEl.method;
    const action = currentFormEl.action;
    currentFormEl.addEventListener('submit', e => {
        e.preventDefault();
        e.stopPropagation();
        currentFormEl.style.display = 'none';
        spinner.classList.remove('spv-spinner--done');
        spinner.classList.add('spv-spinner--active');
        new FormData(currentFormEl);
    });
    currentFormEl.addEventListener('formdata', e => {
        const data = e.formData;
        fetch(action, {
            method: method,
            body: data,
        })
            .then(response => response.text())
            .then(text => {
            applyResponse(text, resultContainer, currentFormEl, spinner);
            setTimeout(() => {
                spinner.classList.remove('spv-spinner--active');
            }, 200);
        });
    });
}
function applyResponse(res, resultContainer, currentFormEl, spinner) {
    const resAsDom = document.createRange().createContextualFragment(res);
    const newResults = resAsDom.querySelector('.spv-moreResults__container');
    const newResultsItems = newResults?.children;
    if (newResultsItems) {
        for (let i = 0; i < newResultsItems.length; i++) {
            resultContainer.appendChild(newResultsItems[i]);
            if (i === 0) {
                const firstLink = resultContainer.lastElementChild?.querySelector('a');
                firstLink?.focus();
            }
        }
    }
    else {
        console.warn('Got no results!?');
    }
    const newForm = resAsDom.querySelector('form.spv-moreResults__form');
    if (newForm) {
        currentFormEl.after(newForm);
        configureForm(resultContainer, newForm, spinner);
        currentFormEl.remove();
    }
}
function moreResults() {
    const moreForm = document.querySelector('form.spv-moreResults__form');
    const moreContainer = document.querySelector('.spv-moreResults__container');
    const spinner = document.querySelector('.spv-moreResults__spinner');
    if (moreForm && moreContainer && spinner) {
        spinner.setAttribute('aria-live', 'polite');
        configureForm(moreContainer, moreForm, spinner);
    }
}
window.addEventListener('DOMContentLoaded', () => {
    moreResults();
});
//# sourceMappingURL=more-results.js.map